import { render, staticRenderFns } from "./sm-hateoas-filter-terms.vue?vue&type=template&id=089d1f14&scoped=true&"
import script from "./sm-hateoas-filter-terms.vue?vue&type=script&lang=js&"
export * from "./sm-hateoas-filter-terms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089d1f14",
  null
  
)

export default component.exports